export default __webpack_public_path__ + "static/media/3x.aad07dd9.png";